import { useLocation } from "react-router-dom";
import Header from "./containers/header";
import PageRoutes from "./routes";
import { Toaster } from "@/components/ui/toaster";
import GlobalLoader from "@/components/loader";
import { RootState } from "./redux/reducers";
import { useSelector } from "react-redux";

function App() {
  const location = useLocation();
  const isHeaderHidden = ["/login", "/accept-invitation"].includes(
    location.pathname
  );
  const { loader } = useSelector((state: RootState) => state.common);
  return (
    <>
      {!isHeaderHidden && <Header />}
      <PageRoutes />
      <Toaster />
      <GlobalLoader open={loader as boolean} />
    </>
  );
}

export default App;
